import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';
import * as moment from 'moment';
import { RemitosService } from 'src/app/services/visit/remitos.service';
import { Client } from '../activity/models/Client'; // misma interface que usás en Activity

// Ajustá estos campos a tu payload real
export interface Remito {
  empresa?: string;
  remito?: string;        // o "comprobante" si así viene
  fecha?: string | Date;
  total?: number;
  pdf?: string;

  [key: string]: any;
}

@Component({
  selector: 'app-remitos',
  templateUrl: './remitos.component.html',
  styleUrls: ['./remitos.component.scss'],
})
export class RemitosComponent implements OnInit {
  show = false;

  clients: any;
  options: Client[] = [];
  filteredClients: any;

  remitosForm!: FormGroup;

  dataSource = new MatTableDataSource<Remito>([]);
  displayedColumns: string[] = ['empresa', 'fecha', 'remito', 'total', 'pdf'];

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(
    private remitosService: RemitosService,
    private datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    const now = moment().format('YYYY-MM-DD');

    this.clients = JSON.parse(sessionStorage.getItem('session') || '{}');
    this.options = this.clients?.dsSesion?.ttcliente ?? [];

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.remitosForm = this.formBuilder.group({
      code: [this.clients?.dsSesion?.ttcliente?.[0]?.codigo, Validators.required],
      since: [moment().subtract(3, 'months').format('YYYY-MM-DD'), Validators.required],
      from: [now, Validators.required],
    });

    // Igual que Activity: si es cliente, consulta automática
    if (this.clients?.dsSesion?.ttsesion?.[0]?.tipo === 'cliente') {
      this.onSubmit(this.remitosForm);
    }
  }

  filterClients(value: any) {
    const filterValue = (value ?? '').toString().toUpperCase();
    this.filteredClients = this.options.filter(
      (client: any) =>
        client.nombre?.toUpperCase().indexOf(filterValue) === 0 ||
        client.codigo?.toString().includes(filterValue)
    );
  }

  displayNm(client: any) {
    return client ? client['nombre'] : undefined;
  }

  onSubmit(form: FormGroup) {
    this.spinner.show();
    this.show = true;

    if (form.status === 'INVALID') {
      this.spinner.hide();
      return this.showAlert('Campos Requeridos*', 'Cerrar');
    }

    // Fecha dd/MM/yyyy (igual que Activity)
    const s = this.datepipe.transform(form.value.since, 'dd-MM-yyyy')!;
    const f = this.datepipe.transform(form.value.from, 'dd-MM-yyyy')!;

    // En vendedor: code es objeto; en cliente: puede venir string/number
    const rawCode = form.value.code;
    const code = rawCode?.codigo ? rawCode.codigo : rawCode;

    return this.remitosService.get(String(code), s, f).subscribe(
      (response: any) => {
        // ✅ Acá ajustás la key real. Te dejo 3 opciones comunes:
        const rows =
          response?.remitos ??
          response?.data ??
          response?.movi ?? // por si el backend recicla nombre
          [];

        if (!Array.isArray(rows) || rows.length === 0) {
          this.showAlert('No se encontraron datos', 'Cerrar');
          this.show = false;
          this.spinner.hide();
          this.dataSource.data = [];
          return;
        }

        this.dataSource.data = rows;
        this.show = true;
        this.spinner.hide();
      },
      () => {
        this.showAlert('Error, vuelva a intentar', 'Cerrar');
        this.show = false;
        this.spinner.hide();
      }
    );
  }

  /** Filter */
  applyFilter(filterValue: string): void {
    this.dataSource.filter = (filterValue ?? '').trim().toLowerCase();
  }

  /** Alert */
  showAlert(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 2000 });
  }
}
